import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

import Login from './Login';
import Dashboard from './Dashboard';
import Statements from './Statements';
import MyLedger from './MyLedger';
import LiveGames from './LiveGames';
import L7A from './L7A';
import DTT20 from './DTT20';
import TPT20 from './TPT20';
import TPOdi from './TPOdi';
import AB2 from './AB2';
import AAA from './AAA';
import AAA_v2 from './AAA_v2';
import BBB from './BBB';
import WM from './WM';
import Matka from './Matka';
import MatkaBet from './MatkaBet';
import MSPosition from './MSPosition';
import MSPosition1 from './MSPosition1';
import Passbook from './Passbook';
import Declared from './Declared';
import ChangePassword from './ChangePassword';
import ChangePasswordAFL from './ChangePasswordAFL';
import Logout from './Logout';
import Aviator from './Aviator';
import Exposure from './Exposure';
import CompletedFancy from './CompletedFancy';
import TPT20Result from './TPT20Result';
import TPOdiResult from './TPOdiResult';
import DTT20Result from './DTT20Result';
import L7AResult from './L7AResult';
import AB2Result from './AB2Result';
import AAAResult from './AAAResult';
import WMResult from './WMResult';
import BBBResult from './BBBResult';

import Layout from './Layout';
//import LayoutLogin from './LayoutLogin';

function App() {
  return ( // Add 'return' statement
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />}>
         
        </Route>

        <Route path="/Aviator" element={<Aviator />}>
         
        </Route>

        <Route path="/ChangePasswordAFL" element={<ChangePasswordAFL />}>
         
        </Route>

        <Route path="/Dashboard" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="Statements" element={<Statements />} />
          <Route path="MyLedger" element={<MyLedger />} />
          <Route path="LiveGames" element={<LiveGames />} />
          <Route path="Passbook" element={<Passbook />} />
          <Route path="MSPosition/:MatchCode/:MatchID/:MatchType" element={<MSPosition />} />
          <Route path="MSPosition1/:MatchCode/:MatchID" element={<MSPosition1 />} />
          <Route path="L7A" element={<L7A />} />
          <Route path="DTT20" element={<DTT20 />} />
          <Route path="TPT20" element={<TPT20 />} />
          <Route path="TPOdi" element={<TPOdi />} />
          <Route path="AB2" element={<AB2 />} />
          <Route path="AAA" element={<AAA />} />
          <Route path="AAA_v2" element={<AAA_v2 />} />
          <Route path="BBB" element={<BBB />} />
          <Route path="WM" element={<WM />} />
          <Route path="TPT20Result" element={<TPT20Result />} />
          <Route path="TPOdiResult" element={<TPOdiResult />} />
          <Route path="DTT20Result" element={<DTT20Result />} />
          <Route path="L7AResult" element={<L7AResult />} />
          <Route path="AB2Result" element={<AB2Result />} />
          <Route path="AAAResult" element={<AAAResult />} />
          <Route path="WMResult" element={<WMResult />} />
          <Route path="BBBResult" element={<BBBResult />} />
          <Route path="Matka" element={<Matka />} />
          <Route path="Exposure" element={<Exposure />} />
          <Route path="MatkaBet/:LID/:LN/:OBT/:CBT/:AN/:RN" element={<MatkaBet />} />
          <Route path="Declared/:gt/:mn/:id/:dt" element={<Declared />} />
          <Route path="ChangePassword" element={<ChangePassword />} />
          <Route path="Logout" element={<Logout />} />
          {/* <Route path="Aviator" element={<Aviator />} /> */}
          <Route path="CompletedFancy/:MatchCode" element={<CompletedFancy />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
